export const PROJECTS = [
  {
    name: 'Dietela',
    description: `
      Dietela is a mobile application that provides personalised diet and online nutritionist consultation services,
      built with ##React Native##, ##Typescript##, and ##Django REST##.
    `,
    imageUrl:
      'https://drive.google.com/uc?export=view&id=10Ms3pKAVNN6Vc0rjVIviovDtFuN7JAWG',
    repo: [
      {
        label: 'Mobile',
        url:
          'https://gitlab.cs.ui.ac.id/ppl-fasilkom-ui/2021/DD/pt-gizi-sehat-dietela/dietela-mobile',
      },
      {
        label: 'BE',
        url:
          'https://gitlab.cs.ui.ac.id/ppl-fasilkom-ui/2021/DD/pt-gizi-sehat-dietela/dietela-backend',
      },
    ],
  },
  {
    name: 'ChatApp',
    description: `
      ChatApp is a multi-person real-time chatting application with Google auth 
      and read-by feature, built with ##React Typescript## and ##Elixir Phoenix##.
    `,
    imageUrl:
      'https://drive.google.com/uc?export=view&id=1wOq1BtWYyV8ixxg-nH-4TP6tXgVYds8_',
    repo: [
      {
        label: 'FE',
        url: 'https://gitlab.cs.ui.ac.id/kelompok-pemfung/cafe',
      },
      {
        label: 'BE',
        url: 'https://gitlab.cs.ui.ac.id/kelompok-pemfung/chatapp',
      },
    ],
  },
  {
    name: 'Requirements Gatherer',
    description: `
      Requirements Gatherer is a one-stop application for organizations to define software project 
      requests and requirements from clients, built with ##React.js## and ##Django REST##.
    `,
    imageUrl:
      'https://drive.google.com/uc?export=view&id=16jYn_f0J8w2pmI1IBlPRmeZ44o7m1zPH',
    repo: [
      {
        label: 'FE',
        url: 'https://gitlab.com/pti-bemcsui/hera',
      },
      {
        label: 'BE',
        url: 'https://gitlab.com/pti-bemcsui/zeus',
      },
    ],
  },
  {
    name: 'Scoovid',
    description: `
      Scoovid is an AI-powered, ##Django-based## scheduling website for companies that runs on
      ##Genetic Algorithm## considering productivity and risk of COVID transmission.
    `,
    imageUrl:
      'https://drive.google.com/uc?export=view&id=1IE4BM_MsczciOwnq2n9mn1cieeoujWyS',
    repo: [
      {
        url: 'https://gitlab.com/sc-yok/scoovid',
      },
    ],
  },
  {
    name: 'Dorakula',
    description: `
      Dorakula is a web application that handles donor registry and management for
      the Indonesian Red Cross Society, built with ##React.js## and ##Django REST##.
    `,
    imageUrl:
      'https://drive.google.com/uc?export=view&id=1Zni28xJS-xTqAoitM9lbFYC_woZ18_wB',
    repo: [
      {
        label: 'FE',
        url: 'https://gitlab.com/pti-bemcsui/artemis',
      },
      {
        label: 'BE',
        url: 'https://gitlab.com/pti-bemcsui/apollo',
      },
    ],
  },
  {
    name: 'Chatatan',
    description: `
      Chatatan is a LINE bot application serving as a personal notes and schedule keeper
      with a share feature, built with microservices and TDD using ##Spring## and ##PostgreSQL##.
    `,
    imageUrl:
      'https://drive.google.com/uc?export=view&id=1spvq1uKSanSv4WJoykwWPu7KJhAe_jec',
    repo: [
      {
        label: 'Handler',
        url: 'https://gitlab.com/chatatan-bot/chatatan',
      },
      {
        label: 'API',
        url: 'https://gitlab.com/chatatan-bot/schedule-api',
      },
    ],
  },
  {
    name: `Wulan's Portfolio`,
    description: `
      Wulan's Portfolio is a personal website displaying the recap of productive
      things I have done, built using ##React Typescript##.
    `,
    imageUrl:
      'https://drive.google.com/uc?export=view&id=1LiqXubEUmwLiYNli8Tb5LiFwhvD6DnId',
    repo: [
      {
        url: 'https://github.com/wulanmantiri/portfolio',
      },
    ],
  },
]
